export default __webpack_public_path__ + "static/media/croatia_proj_activities.ccb10620.zip";